import React from 'react';

import { ReportDefinition } from 'containers/ReportsAdvancedPage/reportDefinitions';

import { getPeriods, PERIODS_DEFINITION, SinglePeriod } from './periodsDefinition';

interface Props {
  active?: PERIODS_DEFINITION;
  onClick: (type: PERIODS_DEFINITION) => void;
  reportType?: ReportDefinition;
}

const styleFoSingleBox = {
  padding: '8px 16px',
  borderRadius: 20,
  cursor: 'pointer',
};
const styleForActiveSingleBox = {
  ...styleFoSingleBox,
  background: 'linear-gradient(121.93deg, #5128AA 0%, #7C99F8 100%)',
  color: 'white',
};

const PeriodSwitcher: React.FC<Props> = (props: Props) => {
  const { active, onClick, reportType } = props;
  const periods = getPeriods(reportType);

  return (
    <div
      style={{
        display: 'flex',
        background: 'white',
        borderRadius: 20,
        height: 40,
      }}
    >
      {periods.map((item: SinglePeriod) => (
        <div
          role="button"
          aria-hidden="true"
          key={item.type}
          style={item.type === active ? styleForActiveSingleBox : styleFoSingleBox}
          onClick={(): void => {
            onClick(item.type);
          }}
        >
          <span style={{ fontSize: 12 }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PeriodSwitcher;
